import { createSlice } from '@reduxjs/toolkit';

const initialState = {
 showMenuTab : true,
}

export const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    UpdateMenuTab: (state, action) => {
        state.showMenuTab = action.payload;
    },
  },
})

// Action creators are generated for each case reducer function
export const { UpdateMenuTab } = menuSlice.actions;

export default menuSlice.reducer